module.exports = "<section class=\"login login-page\">\n    <div ui-view></div>\n</section>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/auth/views/index.html
 ** module id = 442
 ** module chunks = 0
 **/